/**
 * Runs the function to get the permission from the user, and then return the selected media streams
 * @export
 * @async
 * @param {MediaConstraints} constraints
 * @returns {(Promise<MediaStream | unknown | undefined>)}
 */
export async function getMedia(constraints) {
    let stream = null;
    try {
        stream || (stream = await navigator.mediaDevices.getUserMedia(constraints));
        return stream;
    }
    catch (err) {
        return err;
    }
}
/**
 * Example camera return
 * @type {*}
 */
export const camera = getMedia({
    audio: false,
    video: true,
});
/**
 * Example audio return
 *
 * @type {*}
 */
export const audio = getMedia({
    audio: true,
    video: false,
});
/**
 * Example audio and camera retyrn
 * @type {*}
 */
export const audioAndCamera = getMedia({
    audio: true,
    video: true,
});
//# sourceMappingURL=media.js.map